import produtor from './produtor'
import unidadenegocio from './unidadenegocio'
import tecnico from './tecnico'
import produto from './produto'
import fornecedor from './fornecedor'
import catalogo from './catalogo'

export default {
  produtor,
  unidadenegocio,
  tecnico,
  produto,
  fornecedor,
  catalogo,
}
